import { Cell, PersonBlock, useContainerWidth } from '@fs/zion-ui'
import React from 'react'
import { bool, func, number, oneOfType, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { usePreference } from '@fs/zion-preferences'
import { getDisplayName } from '../../../../shared/helpers/name_formatting'

const personButton = css`
  cursor: pointer;
`

const pipe = css`
  color: #e0e2e2;
`

const yearLabel = css`
  font-weight: bold;
`

const yearDescription = css`
  font-weight: normal;
  color: #999999;
`

export default function BirthYearPersonTile({ person, tileClickHandler, inDiscoveryCenter = false }) {
  const atWidth = useContainerWidth()
  const [t] = useTranslation()
  const showRoman = usePreference('tree.showNamesInRomanScript')

  const { name, surname, gender, portraitThumbnailLink, dob: birthYear } = person

  const blockSize = inDiscoveryCenter ? 'xl' : 'lg'

  return (
    <Cell columns={atWidth({ default: 12, md: 6, xl: 4, xxl: 3 })}>
      <div
        data-testid="birth-year-person-tile"
        css={personButton}
        role="button"
        tabIndex={0}
        onClick={() => tileClickHandler(person)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') tileClickHandler(person)
        }}
      >
        <PersonBlock
          size={blockSize}
          name={getDisplayName(person, showRoman)}
          avatarProps={{
            src: portraitThumbnailLink,
            sex: gender,
            monogram: `${name?.[0] ?? ''}${surname?.[0] ?? ''}`,
          }}
          details={PersonBirthTileDetails({ birthYear, t })}
        />
      </div>
    </Cell>
  )
}

function PersonBirthTileDetails({ birthYear, t }) {
  const birthYearDisplay = birthYear || t('aam.year-picker.add-birth-year', 'Add Birth Year')
  return (
    <span>
      <span css={yearLabel}>{birthYearDisplay}</span>
      <span css={pipe}> | </span>
      <span css={yearDescription}>{t('aam.year-picker.birth-year', 'Birth Year')}</span>
    </span>
  )
}

BirthYearPersonTile.propTypes = {
  person: shape({
    name: string,
    surname: string,
    gender: string,
    portraitThumbnailLink: string,
    birthYear: oneOfType([string, number]),
  }),
  tileClickHandler: func,
  inDiscoveryCenter: bool,
}
